module.exports = __webpack_public_path__ + "img/earth.11dc1cec.svg";